var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2685_2263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2.00065C8 1.63246 7.70152 1.33398 7.33333 1.33398H3.33333C1.49238 1.33398 0 2.82637 0 4.66732V12.6673C0 14.5083 1.49238 16.0007 3.33333 16.0007H11.3333C13.1743 16.0007 14.6667 14.5083 14.6667 12.6673V8.66732C14.6667 8.29913 14.3682 8.00065 14 8.00065C13.6318 8.00065 13.3333 8.29913 13.3333 8.66732V12.6673C13.3333 13.7719 12.4379 14.6673 11.3333 14.6673H3.33333C2.22876 14.6673 1.33333 13.7719 1.33333 12.6673V4.66732C1.33333 3.56275 2.22876 2.66732 3.33333 2.66732H7.33333C7.70152 2.66732 8 2.36884 8 2.00065Z",
    fill: "#1F8475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3478 -0.00194752L14.0153 0.0169082C14.5453 0.017238 15.0535 0.227927 15.4283 0.602695C15.8031 0.977462 16.0137 1.48566 16.0141 2.01566L16.0188 5.66905C16.0192 5.75706 16.0021 5.84426 15.9686 5.92564C15.9351 6.00702 15.8858 6.08096 15.8235 6.14319C15.7613 6.20542 15.6874 6.25471 15.606 6.28822C15.5246 6.32174 15.4374 6.3388 15.3494 6.33844C15.2614 6.3388 15.1742 6.32174 15.0928 6.28822C15.0114 6.25471 14.9375 6.20542 14.8753 6.14319C14.813 6.08096 14.7637 6.00702 14.7302 5.92564C14.6967 5.84426 14.6796 5.75706 14.68 5.66905L14.6847 2.26079L8.95132 7.99419C8.69097 8.25454 8.26886 8.25454 8.00851 7.99419C7.74816 7.73384 7.74816 7.31173 8.00851 7.05138L13.7136 1.34627L10.3431 1.33213C10.167 1.3316 9.9982 1.26141 9.87366 1.13687C9.74912 1.01233 9.67893 0.84357 9.6784 0.667447C9.67804 0.57944 9.69511 0.492232 9.72862 0.410854C9.76213 0.329476 9.81143 0.25554 9.87366 0.193309C9.93589 0.131078 10.0098 0.0817848 10.0912 0.0482724C10.1726 0.01476 10.2598 -0.00230835 10.3478 -0.00194752Z",
    fill: "#1F8475"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2685_2263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.6b9e4c77a86a8bbee81d8f91f537e51d.svg";
export { ForwardRef as ReactComponent };